import View from './view';
export const UserCardMobile = View;
